import { defineMessages } from 'react-intl.macro';
import { GEODESIST_IS_ACTIVE } from '../constants';

export const geodesistMessages = defineMessages({
  geodesistDetailTitle: {
    id: 'geodesistDetail.title',
    defaultMessage: '{id, select, empty {Geodet} other {Geodet č. {id}}}',
  },
  geodesistListPageTitle: {
    id: 'geodesistList.PageTitle',
    defaultMessage: 'Přehled geodetů',
  },
  geodesistListStateWaiting: {
    id: 'geodesistList.state.waiting',
    defaultMessage: 'Seznam geodetů se načítá.',
  },
  geodesistListStateFail: {
    id: 'geodesistList.state.fail',
    defaultMessage: 'Seznam geodetů se nepovedlo načíst.',
  },
  geodesistListStateFilteredEmpty: {
    id: 'geodesistList.state.filteredEmpty',
    defaultMessage: 'Zadanému filtru neodpovídá žádný záznam.',
  },
  name: {
    id: 'geodesistList.name',
    defaultMessage: 'Název',
  },
  isActive: {
    id: 'geodesistList.isActive',
    defaultMessage: 'Aktivní geodet',
  },
  officialNumber: {
    id: 'geodesistList.officialNumber',
    defaultMessage: 'Číslo geodeta',
  },
  hasCertification: {
    id: 'geodesistList.btn.hasCertification',
    defaultMessage: 'Certifikáty A/B/C',
  },
  search: {
    id: 'geodesistList.search',
    defaultMessage: 'Název geodeta',
  },
  note: {
    id: 'geodesistList.note',
    defaultMessage: 'Poznámka',
  },
});

export const geodesistQueryMessages = defineMessages({
  loadQueryStateWaiting: {
    id: 'geodesist.load.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  loadQueryStateFail: {
    id: 'geodesist.load.queryState.fail',
    defaultMessage: 'Zobrazení informací o geodetu se nepovedlo. Zkuste to prosím později.',
  },
  submitQueryStateWaiting: {
    id: 'geodesist.submit.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  submitQueryStateSuccess: {
    id: 'geodesist.submit.success',
    defaultMessage: 'Změny uloženy.',
  },
  submitQueryStateFail: {
    id: 'geodesist.submit.fail',
    defaultMessage: 'Uložení změn se nepovedlo. Zkuste to prosím později.',
  },
});

export const geodesistBtnMessages = defineMessages({
  filterSubmit: {
    id: 'geodesist.btn.filterSubmit',
    defaultMessage: 'Filtrovat',
  },
  filter: {
    id: 'geodesist.btn.filter',
    defaultMessage: 'Filtr',
  },
  clear: {
    id: 'geodesist.btn.clear',
    defaultMessage: 'Vyčistit',
  },
  save: {
    id: 'geodesist.btn.save',
    defaultMessage: 'Uložit',
  },
  exportCsv: {
    id: 'subject.btn.exportCsv',
    defaultMessage: 'Export do CSV',
  },
});

export const isActiveMessages = defineMessages<GEODESIST_IS_ACTIVE>({
  [GEODESIST_IS_ACTIVE.TRUE]: {
    id: 'geodesist.isActive.TRUE',
    defaultMessage: 'Ano',
  },
  [GEODESIST_IS_ACTIVE.FALSE]: {
    id: 'geodesist.isActive.FALSE',
    defaultMessage: 'Ne',
  },
});
